interface RuntimeEnvConfig {
  APP_ENVIRONMENT: string;
  CDN_BASE_URL: string;
  APP_VERSION: string;
  STATSIG_CLIENT_KEY: string;
  POSTHOG_API_KEY: string;
  POSTHOG_API_HOST: string;
  MOBILE_APP_DEEP_LINK_SCHEME: string;
  MOBILE_APP_LINK_HOST: string;
  MOBILE_APP_ANDROID_PACKAGE: string;
  MOBILE_APP_IOS_APP_STORE_ID: string;
  BROWSER_EXTENSION_ID: string;
}

declare global {
  interface Window {
    __ENV__?: Partial<RuntimeEnvConfig>;
  }
}

function getEnv(): Partial<RuntimeEnvConfig> {
  return window.__ENV__ ?? {};
}

export function getAppEnvironment() {
  return getEnv().APP_ENVIRONMENT ?? 'development';
}

export function getCdnBaseUrl() {
  return getEnv().CDN_BASE_URL ?? '';
}

export function getAppVersion() {
  return getEnv().APP_VERSION ?? '1.0.0';
}

export function getStatsigClientKey() {
  // K8s: entrypoint injects into window.__ENV__ at container startup
  const runtimeKey = getEnv().STATSIG_CLIENT_KEY ?? '';

  if (runtimeKey) {
    return runtimeKey;
  }

  // pnpm dev: Vite reads VITE_STATSIG_CLIENT_KEY from .env.local
  return import.meta.env.VITE_STATSIG_CLIENT_KEY ?? '';
}

export function getPosthogApiKey() {
  const runtimeKey = getEnv().POSTHOG_API_KEY ?? '';

  if (runtimeKey) {
    return runtimeKey;
  }

  return import.meta.env.VITE_POSTHOG_API_KEY ?? '';
}

export function getPosthogApiHost() {
  const runtimeHost = getEnv().POSTHOG_API_HOST ?? '';

  if (runtimeHost) {
    return runtimeHost;
  }

  return import.meta.env.VITE_POSTHOG_API_HOST ?? '';
}

export function getMobileAppDeepLinkScheme() {
  return getEnv().MOBILE_APP_DEEP_LINK_SCHEME ?? '';
}

export function getMobileAppLinkHost() {
  return getEnv().MOBILE_APP_LINK_HOST ?? '';
}

export function getMobileAppAndroidPackage() {
  return getEnv().MOBILE_APP_ANDROID_PACKAGE ?? '';
}

export function getMobileAppIosAppStoreId() {
  return getEnv().MOBILE_APP_IOS_APP_STORE_ID ?? '';
}

export function getExtensionId() {
  return getEnv().BROWSER_EXTENSION_ID ?? '';
}

export function isValidEnvValue(value: string, placeholder: string) {
  return value.length > 0 && value !== placeholder;
}
